import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronDown,
  faChevronRight,
  faChevronCircleUp,
  faChevronCircleDown,
  faPlusCircle,
  faCheckCircle,
  faMinusCircle,
  faLongArrowAltRight,
  faTimesCircle,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import store, { history } from './ducks/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';
import 'ol/ol.css';
import 'ol-geocoder/dist/ol-geocoder.min.css';
import ScrollToTop from './components/ScrollToTop';
import GaTracker from "./components/GaTracker";
import {PostHogProvider} from "posthog-js/react";

library.add(
  faChevronDown,
  faChevronRight,
  faCheckCircle,
  faChevronCircleUp,
  faChevronCircleDown,
  faPlusCircle,
  faMinusCircle,
  faLongArrowAltRight,
  faTimesCircle,
  faInfoCircle
);

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://acc7624b67f348778baee30e2de7181b@o414304.ingest.sentry.io/5304606',
    ignoreErrors: [/Object Not Found Matching Id/],
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTop />
      <GaTracker />
      <PostHogProvider
        apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
        options={options}
      >
        <App />
      </PostHogProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
